module.exports = {"advertManage":{"columns":{"siderName":"广告名称","fileUrl":"图片","url":"链接/栏目","operation":"操作"}}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh.advertManage.json
// module id = tAEE
// module chunks = 63 64